import { useState, useEffect } from "react";
import { GET_NEWS } from '../api/constants'

export const useNewsList = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchNews = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await fetch(GET_NEWS);
        const data = await response.json();

        if (data.status) {
          setNews(data.data || []);
        } else {
          setNews([]);
          setError(data.message || "Failed to fetch news");
        }
      } catch (err) {
        console.error("Error fetching news:", err);
        setError("Failed to fetch news");
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, []);

  return { news, loading, error };
};
